import { FIND_PAY_ADMIN_TO_DRIVER, FIND_USER } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";

async function findAdminToDriver(props: any) {
  var thisUrl = FIND_PAY_ADMIN_TO_DRIVER;
  let page = 1;
  let limit = 10;
  if (props.page) page = props.page;
  if (props.limit) limit = props.limit;

  let body: any = {
    page,
    limit,
    populate: "driver",
    sort: props.sort,
  };

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ FIND_PAY_ADMIN_TO_DRIVER: error });
  }
}

export default findAdminToDriver;
